export default __webpack_public_path__ + "static/media/cover.768b1187.png";